import { DialogActions, DialogContent, Unstable_Grid2 as Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@/components/common/LoadingButton';
import { FormTextField } from '@/components/HookForm';
import { dialogClose } from '@/modules/MuiDialog';
import { toast } from 'react-toastify';
import { patchMallBusinessInfo } from '@/services/mall.service';
import DialogTitleBox from '@/modules/MuiDialog/DialogTitleBox';
import { useTranslation } from 'react-i18next';

interface SingleFieldDialogProps {
    mallId: string;
    /** patch payload 키 (예: companyName) */
    field: string;
    /** 화면에 보일 라벨 */
    label: string;
    /** 현재 값 */
    value?: string;
    /** 저장 직전 값 가공(정규화 등). 없으면 입력값 그대로 저장 */
    transform?: (v: string) => string;
}

/**
 * 사업자 정보를 "한 항목씩" 수정하는 공용 다이얼로그.
 * patchMallBusinessInfo 가 부분 업데이트(PATCH)라 해당 필드 하나만 보낸다.
 * (서류 업로드가 필요한 항목은 CertFieldDialog, 계좌 3종은 실명인증 때문에 AccountInfoDialog 사용)
 */
export const SingleFieldDialog = (props: SingleFieldDialogProps) => {
    const { t } = useTranslation();
    const form = useForm({ defaultValues: { value: props.value || '' } });
    const {
        handleSubmit,
        formState: { isSubmitting },
    } = form;

    async function formSubmit(data: any) {
        const raw = data?.value || '';
        const next = props.transform ? props.transform(raw) : raw;
        // 변경 없으면 그냥 닫기
        if (next === (props.value || '')) {
            dialogClose();
            return;
        }
        try {
            await patchMallBusinessInfo(props.mallId, { [props.field]: next } as any);
            toast.success(t('common.updated'));
            dialogClose();
        } catch (error) {
            toast.error(t('mall.businessInfoUpdateFailed'));
        }
    }

    return (
        <>
            <DialogTitleBox title={`${props.label} ${t('common.edit')}`} />
            <DialogContent>
                <Grid container>
                    <Grid xs={12}>
                        <FormTextField
                            label={props.label}
                            name={'value'}
                            form={form as any}
                            formTrigger={'change'}
                            defaultValue={''}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <LoadingButton
                    isLoading={isSubmitting}
                    onClick={async () => {
                        await handleSubmit(formSubmit)();
                    }}
                >
                    {t('common.edit')}
                </LoadingButton>
                <LoadingButton
                    color={'error'}
                    onClick={() => {
                        dialogClose();
                    }}
                >
                    {t('common.cancel')}
                </LoadingButton>
            </DialogActions>
        </>
    );
};

export default SingleFieldDialog;
